import * as ReactDOM from 'react-dom';

import App from './App';

ReactDOM.render(<App />, document.getElementById(process.env.ROOT_ID || 'widget-chat-v2'));
